module.exports = __webpack_public_path__ + "img/nq.8b480264.png";